import React from 'react';
import { Background, BackgroundProps } from 'react-imgix';

import useImgix from './useImgix';

const BackgroundWrapper: React.FC<BackgroundProps> = ({ src, ...props }) => {
  const { transformImageURL } = useImgix();

  return (
    <Background
      {...props}
      htmlAttributes={{ 'data-test-locator': 'imgix', ...props.htmlAttributes }}
      src={transformImageURL(src, {})}
    />
  );
};

export default BackgroundWrapper;
